// src/utils/taskStatus.ts

// 100% is reserved for status === 'DONE'. While the task is awaiting review
// (or in any other non-final status), cap the displayed percentage so that
// "100%" reads as "completed", not "work submitted, review pending".
export const displayedProgress = (rawPercent: number | null | undefined, status: string): number => {
  const p = Math.max(0, Math.min(100, rawPercent ?? 0));
  return status === 'DONE' ? p : Math.min(p, 90);
};

export const statusFlow = {
  'TODO': { next: 'IN_PROGRESS', prev: null, canStart: true },
  'IN_PROGRESS': { next: 'IN_REVIEW', prev: 'TODO', canSubmit: true },
  'IN_REVIEW': { next: 'DONE', prev: 'IN_PROGRESS', canApprove: true },
  'BLOCKED': { next: 'IN_PROGRESS', prev: null, needsReason: true },
  'DONE': { next: null, prev: 'IN_REVIEW', isFinal: true },
  'CANCELLED': { next: null, prev: null, isFinal: true },
};

export const getAvailableActions = (status: string, userRole: string, isAssignee: boolean) => {
  const actions = [];
  
  if (status === 'TODO' && (isAssignee || userRole === 'admin')) {
    actions.push({ label: 'Start Working', action: 'IN_PROGRESS', color: 'blue' });
  }
  if (status === 'IN_PROGRESS' && isAssignee) {
    actions.push({ label: 'Submit for Review', action: 'IN_REVIEW', color: 'purple' });
    actions.push({ label: 'Block Task', action: 'BLOCKED', color: 'red' });
  }
  if (status === 'IN_REVIEW' && (userRole === 'admin' || userRole === 'manager')) {
    actions.push({ label: 'Approve', action: 'DONE', color: 'green' });
    actions.push({ label: 'Request Changes', action: 'IN_PROGRESS', color: 'orange' });
  }
  if (status === 'BLOCKED' && isAssignee) {
    actions.push({ label: 'Unblock & Continue', action: 'IN_PROGRESS', color: 'blue' });
  }
  
  return actions;
};